export interface IAnnualReportDefaultSettings {
    currency: string;
    /** FX (REV-21512): the display currency's name on an FX report; absent otherwise. */
    displayCurrency?: string;
    currentBalanceDate: string;
    previousBalanceDate: string;
    currentIncomeDate: string;
    previousIncomeDate: string;
    annualReportSelectedForAutofillCurrentBalanceDate?: string;
    annualReportSelectedForAutofillPreviousBalanceDate?: string;
    annualReportSelectedForAutofillCurrentIncomeDate?: string;
    annualReportSelectedForAutofillPreviousIncomeDate?: string;
}
